import Register from "../components/Register";

export default function RegisterPage() {
  return <Register />;
}
